"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GROOVE_UI_ROOT_CLASS = void 0;
// using this prefix for now so prevent conflicts with existing styles
// while we slowly integrate new design into groove
var GROOVE_UI_ROOT_CLASS = '.grui';
exports.GROOVE_UI_ROOT_CLASS = GROOVE_UI_ROOT_CLASS;
//# sourceMappingURL=style.js.map